/* unplugin-vue-components disabled */import { render } from "./w-select-users.vue?vue&type=template&id=7c616cd4&scoped=true&ts=true"
import script from "./w-select-users.vue?vue&type=script&lang=ts"
export * from "./w-select-users.vue?vue&type=script&lang=ts"

import "./w-select-users.vue?vue&type=style&index=0&id=7c616cd4&scoped=true&lang=scss"
import "./w-select-users.vue?vue&type=style&index=1&id=7c616cd4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c616cd4"]])

export default __exports__